import CategoryMapper from './category-mapper';

const CategoryModel = {
    mapper: CategoryMapper,

    countryCode: {
        fieldName: 'u',
        type: String,
    },

    eventCount: {
        type: Number,
    },

    id: {
        fieldName: 'i',
        type: String,
    },

    names: {
        fieldName: 'n',
        type: Object,
    },

    order: {
        fieldName: 'o',
        type: Number,
    },
};

export default CategoryModel;
